var SUBMENU_ITEM_MAX_LEN_WITHOUT_TOOLTIP = 17;
export { SUBMENU_ITEM_MAX_LEN_WITHOUT_TOOLTIP };